module.exports = __webpack_public_path__ + "images/category_lp/camera/new/store_images/4@2x_44c7a38d8db56ff85238c8f96e2c7bbb.png";